module.exports = __webpack_public_path__ + "static/media/network.c6a3efe9.png";